/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_All_Invoices_PaidInputs */

const en_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All invoices paid`)
};

const de_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Rechnungen bezahlt`)
};

const es_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las facturas pagadas`)
};

const fr_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les factures payées`)
};

const it_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le fatture pagate`)
};

const pt_br2_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as faturas pagas`)
};

const pl_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie faktury opłacone`)
};

const hu_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden számla kifizetve`)
};

const ro_admin_dashboard_all_invoices_paid = /** @type {(inputs: Admin_Dashboard_All_Invoices_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate facturile platite`)
};

/**
* | output |
* | --- |
* | "All invoices paid" |
*
* @param {Admin_Dashboard_All_Invoices_PaidInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_all_invoices_paid = /** @type {((inputs?: Admin_Dashboard_All_Invoices_PaidInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_All_Invoices_PaidInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "de") return de_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "es") return es_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "fr") return fr_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "it") return it_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "pl") return pl_admin_dashboard_all_invoices_paid(inputs)
	if (locale === "hu") return hu_admin_dashboard_all_invoices_paid(inputs)
	return ro_admin_dashboard_all_invoices_paid(inputs)
});
export { admin_dashboard_all_invoices_paid as "admin.dashboard.all_invoices_paid" }